"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBetsSaga = fetchBetsSaga;
exports.processBetsHistorySideEffectsSaga = processBetsHistorySideEffectsSaga;
exports.processPlayersSaga = processPlayersSaga;
exports.deleteBetsSaga = deleteBetsSaga;
exports.fetchHistoryBetsPageSaga = fetchHistoryBetsPageSaga;
exports.fetchBetsStatisticsSaga = fetchBetsStatisticsSaga;
exports.makeCashoutSaga = makeCashoutSaga;
exports.betsHistoryProviderSaga = betsHistoryProviderSaga;
const effects_1 = require("redux-saga/effects");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const CoreConfiguration_1 = __importDefault(require("../../config/CoreConfiguration"));
const utils_1 = require("../../domain/players/utils");
const selectors_1 = require("../LanguagesProvider/selectors");
const saga_1 = require("../AccountProvider/saga");
const slice_1 = require("../PlayersProvider/slice");
const format_1 = require("../../utils/format");
const env_1 = require("../../utils/env");
const sse_1 = require("../../utils/sse");
const errors_1 = require("../../utils/errors");
const api_1 = require("../../api/bets/api");
const ConfigProvider_1 = require("../ConfigProvider");
const saga_2 = require("../ConfigProvider/saga");
const utils_2 = require("./utils");
const slice_2 = require("./slice");
const types_1 = require("./types");
const selectors_2 = require("./selectors");
const constants_1 = require("./constants");
const SOURCE_KEY = 'betsHistoryPage';
function* fetchBetsSaga(action) {
    const { reqData, sideEffects: { onSuccess, onError } = {} } = action.payload;
    try {
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const accountId = yield (0, effects_1.call)(saga_1.getAccountId);
        const { data: resData } = yield (0, effects_1.call)(api_1.getBets, {
            ...reqData,
            locale,
            accountId,
        });
        yield (0, effects_1.fork)(processBetsHistorySideEffectsSaga, { resData });
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.fetchBetsSuccess({ resData }));
        if (onSuccess) {
            yield (0, effects_1.put)(onSuccess({ reqData, resData }));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching bets', error);
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.fetchBetsError(error));
        if (onError) {
            yield (0, effects_1.put)(onError(error));
        }
    }
}
function* processBetsHistorySideEffectsSaga({ resData, }) {
    yield (0, effects_1.fork)(processPlayersSaga, { resData });
}
// fetching player names to show in history table by ids
function* processPlayersSaga({ resData }) {
    const playersIds = (0, utils_1.getPlayerIdsForBetsHistory)(resData.items);
    yield (0, effects_1.put)(slice_1.playersProviderActions.fetchPlayers({ playersIds }));
}
function* deleteBetsSaga() {
    try {
        yield (0, effects_1.call)(api_1.deleteBets);
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.deleteBetsSuccess());
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while deleting bets', error);
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.deleteBetsError(error));
    }
}
function* fetchHistoryBetsPageSaga(action) {
    var _a, _b;
    const dates = yield (0, effects_1.select)(selectors_2.selectBetsHistoryDates);
    const betsStatus = yield (0, effects_1.select)(selectors_2.selectBetsHistoryBetsStatus);
    const gameVendor = yield (0, effects_1.select)(selectors_2.selectBetsHistoryGameVendor);
    const betsTypes = yield (0, effects_1.select)(selectors_2.selectBetsHistoryBetsTypes);
    const pagination = yield (0, effects_1.select)(selectors_2.selectBetsHistoryPagination);
    const reqData = {
        ...(0, utils_2.getFilters)({ dates, betsStatus, gameVendor, betsTypes }),
        ...pagination,
        ...((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.requestData) !== null && _b !== void 0 ? _b : {}),
    };
    const isBetsStatusParamsEnabled = yield (0, effects_1.call)(saga_2.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.IS_BETS_STATUSES_PARAM_ENABLED);
    if (isBetsStatusParamsEnabled) {
        reqData.status = undefined;
    }
    yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.fetchBets({
        reqData,
        sideEffects: utils_2.betsHistoryProviderSideEffects[SOURCE_KEY],
    }));
}
function* fetchBetsStatisticsSaga() {
    try {
        const accountId = yield (0, effects_1.call)(saga_1.getAccountId);
        const { data } = yield (0, effects_1.call)(api_1.getBetsStatistics, {
            accountId,
        });
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.fetchBetsStatisticsSuccess(data));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching bets statistics', error);
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.fetchBetsStatisticsError(error));
    }
}
function* subscribeCashoutUpdatesSSESaga() {
    try {
        const accountId = yield (0, effects_1.call)(saga_1.getAccountId);
        if (accountId) {
            const sseConfiguration = yield (0, effects_1.select)((state) => (0, selectors_2.selectCashoutUpdatesSSEConfiguration)(state, accountId));
            let headers;
            // TODO this is not the place
            if (env_1.isReactNative) {
                const accessTokenRaw = yield (0, effects_1.select)((state) => state.storageProvider.storage.accessToken);
                const accessToken = !!accessTokenRaw && JSON.parse(accessTokenRaw);
                headers = { Authorization: `Bearer ${accessToken}` };
            }
            const eventSrc = CoreConfiguration_1.default.getInstance().sseBuilder.createInstance(sseConfiguration, {
                withCredentials: true,
                headers,
            });
            const channel = yield (0, effects_1.call)(sse_1.subscribeToSSE, eventSrc);
            yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.setCashoutChannelSSE(channel));
            while (true) {
                const cashout = yield (0, effects_1.take)(channel);
                const cashoutData = cashout.data;
                const cashoutUpdateMessageData = cashoutData && JSON.parse(String(cashoutData));
                if (cashoutUpdateMessageData &&
                    cashoutUpdateMessageData.cashoutUpdate) {
                    const { cashoutUpdate } = cashoutUpdateMessageData;
                    yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.setCashoutsSSE(cashoutUpdate));
                }
            }
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error subscribeCashoutUpdatesSSESaga', error);
    }
}
function* unsubscribeCashoutUpdatesSSESaga() {
    try {
        const channel = yield (0, effects_1.select)(selectors_2.selectCashoutUpdatesChannelSSE);
        channel === null || channel === void 0 ? void 0 : channel.close();
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.setCashoutChannelSSE(null));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('error unsubscribeCashoutUpdatesSSESaga', error);
    }
}
function* makeCashoutSaga() {
    var _a;
    try {
        const currentCashout = yield (0, effects_1.select)(selectors_2.selectCurrentCashout);
        if (!currentCashout) {
            throw 'Error currentCashout does not exist';
        }
        const { accountId, betId, amount } = currentCashout;
        const { data } = yield (0, effects_1.call)(api_1.sellBet, {
            betSale: {
                accountId,
                betId,
                cashoutAmount: +(0, format_1.adjustAmountForBackend)(amount).toFixed(),
            },
        });
        yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.makeCashoutSuccess(data));
        yield makeCashoutDelaySaga();
    }
    catch (e) {
        if (((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === 400) {
            const error = (0, errors_1.getErrorOrUnknown)(e);
            const isResubscribeSSE = [
                betweb_openapi_axios_1.ErrorCode.CashoutNotAllowed,
                betweb_openapi_axios_1.ErrorCode.IncorrectCashoutAmount,
                betweb_openapi_axios_1.ErrorCode.ClientInvalidAccount,
                betweb_openapi_axios_1.ErrorCode.CashoutNotAvailable,
            ].includes(error.code);
            if (isResubscribeSSE) {
                yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.unsubscribeCashoutSSE());
                yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.makeCashoutError(error));
                yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.subscribeCashoutSSE());
            }
            else {
                yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.makeCashoutError(error));
            }
        }
        else {
            yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.unsubscribeCashoutSSE());
            const error = (0, errors_1.createUnknownError)(constants_1.DEFAULT_ERROR);
            yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.makeCashoutError(error));
        }
        yield makeCashoutDelaySaga();
    }
}
function* makeCashoutDelaySaga() {
    yield (0, effects_1.delay)(constants_1.TIME_DELAY_MAKE_CASHOUT);
    yield (0, effects_1.put)(slice_2.betsHistoryProviderActions.setCashoutStatusView(types_1.ECashoutStatusView.NONE));
}
function* betsHistoryProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.fetchBets.type, fetchBetsSaga),
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.deleteBets.type, deleteBetsSaga),
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.fetchHistoryBetsPage.type, fetchHistoryBetsPageSaga),
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.refreshHistoryBetsPage.type, fetchHistoryBetsPageSaga),
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.fetchBetsStatistics.type, fetchBetsStatisticsSaga),
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.subscribeCashoutSSE, subscribeCashoutUpdatesSSESaga),
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.unsubscribeCashoutSSE, unsubscribeCashoutUpdatesSSESaga),
        (0, effects_1.takeLatest)(slice_2.betsHistoryProviderActions.makeCashout, makeCashoutSaga),
    ]);
}
//# sourceMappingURL=saga.js.map